<template>

    <div class="view-tab" :class="{active: productConfigurationView.active}" @click="chanceActiveTab">
        <div class="view-tab-image">
            <img :src="productConfigurationView.previewUrl">
        </div>
        <div class="view-tab-content">
            <strong>{{productConfigurationView.title}}</strong>
            <p>Druckfläche: {{productConfigurationView.printArea}}</p>
        </div>
        <div class="tab-label-container">
            <div v-if="isEmptyCanvas" class="tab-label">KEINE DRUCKDATEN</div>
            <div v-if="isActive" class="tab-label">AKTIV</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "ViewTab",
        props: {
            productConfigurationView: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            canvas() {
                return this.productConfigurationView.canvas;
            },
            isEmptyCanvas() {
                return this.canvas.getNumberOfCanvasObjects() === 0;
            },
            isActive() {
                return this.productConfigurationView.active;
            }
        },
        methods: {

            chanceActiveTab() {
                if (this.productConfigurationView.active === false)
                    this.$emit('newActiveTab', this.productConfigurationView.id);
            }

        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    .view-tab {
        margin-bottom: 20px;
        display: flex;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        height: 70px;

        &:hover {
            cursor: pointer;
        }

        .view-tab-image img {
            border: 3px solid #DADAE4;
            box-sizing: border-box;
            border-radius: 5px;
            height: 70px;
            width: 70px;
        }

        &.active .view-tab-image img {
            border: 3px solid $blue-color;
        }

        .view-tab-content {
            width: calc(100% - 80px);
        }

        .view-tab-content {
            strong {
                color: #004B92;
                padding: 0;
                margin: 0;
            }
            p {
                font-size: 0.8rem;
                color: #5F7285;
                padding: 0;
                margin: 0;
            }
        }

        .tab-label-container {
            position: absolute;
            bottom: 5px;
            right: 5px;
        }

        .tab-label {
            display: inline-block;
            background-color: #004B92;
            color: #ffffff;
            padding: 3px;
            border-radius: 5px;
            font-size: 0.7em;
        }

        .tab-label:not(:last-of-type) {
            margin-right: 5px;
        }

    }

</style>